<template>
  <USlideover v-model:open="isOpen" :title="$t('Your cart')">
    <template #body>
      <div v-if="cart.pending" class="space-y-3 mb-4">
            <USkeleton class="h-4 w-full" />
            <USkeleton class="h-4 w-full" />
            <USkeleton class="h-4 w-full" />
        </div>
      <div v-else class="flex flex-col h-full">
         <!-- <UAlert title="Limited time offer" description="Use code SAVE10 for 10% off!" class="mb-4" color="info" />
         <UAlert title="Holiday Sale" description="Up to 30% off on selected items!" class="mb-4" color="success" />
         <UAlert title="Free Shipping" description="Enjoy free shipping on orders over $50!" class="mb-6" color="neutral" variant="soft">
            <template #description>
             <p class="mb-2"> Buy $53 more to get Free Shipping! </p>

              <UProgress  v-model="freeShippingProgress" :max="100" color="success" />
            </template>
          </UAlert> -->


        <div v-if="cart.data.items.length === 0" class="flex-1 flex items-center justify-center text-gray-600">
          <div class="text-center">
            <div class="text-4xl mb-4">🛒</div>
            <p>{{ $t('Your cart is empty') }}</p>
          </div>
        </div>

        <div v-else class="flex-1 overflow-y-auto space-y-4">
          <CartItem
            v-for="cartItem in cart.data.items"
            :key="cartItem.id"
            :item="cartItem"
            @update:quantity="(qty: number) => cart.updateItemQuantity(cartItem.id, qty)"
            @remove="cart.removeItem(cartItem.id)"
            @link-click="isOpen = false"
            :currency="cart.data.currency"
          />
        </div>

        <div v-if="cart.data.items.length > 0" class="border-t pt-4 mt-auto">
          <div class="flex justify-between items-center mb-4">
            <span class="font-semibold">Total</span>
            <Price :value="cart.data.total" />
          </div>
          <div class="flex gap-4">
            <UButton :to="$localePath({ name: 'cart' })" @click="isOpen = false" block variant="soft" size="lg" class="py-3">View cart</UButton>
            <CheckoutButton :to="$localePath({ name: 'checkout' })" @click="isOpen = false" block variant="solid" size="lg" class="py-3" />
          </div>
        </div>
      </div>
    </template>
  </USlideover>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import Price from '~/components/molecules/Price.vue'
import CartItem from '~/components/molecules/CartItem.vue'
import { useCartStore } from '~/stores/useCartStore'
import CheckoutButton from '~/components/atoms/CheckoutButton.vue'

const props = defineProps<{ open: boolean }>()
const emit = defineEmits<{ (e: 'update:open', value: boolean): void }>()

const cart = useCartStore()

const isOpen = computed({
  get: () => props.open,
  set: (val: boolean) => emit('update:open', val)
})

const freeShippingProgress = ref(85)
</script>
